import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomerService } from '../customer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'pv-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  message: string;

  constructor(
    private customerService: CustomerService,
    private router: Router
  ) { }

  ngOnInit() {
    if (this.customerService.loggedIn) {
      this.router.navigate(['/profile'])
    }
    this.resetForm = new FormGroup({ email: new FormControl('', [Validators.email, Validators.required]) })
  }

  onSubmit() {
    this.customerService.resetPasswordEmail(this.resetForm.get('email').value)
    .subscribe(
      ({ message }) => this.message = message,
      err => { this.message = err.error.message }
    )
  }
}
